/** @format */

import {divideBySpaces, roundFloatNumber, safeDivide} from 'helpers/numberHelpers';

import {ChartType} from 'components/charts/multiline-chart/model/common';

import {DiffColor} from 'components/charts/multiline-chart/model/tooltip';

import getValueWithToken from '../../helpers/getValueWithToken';

export type CommonChartDataBase = Partial<Record<ChartType, number | undefined>>;

export type TooltipDeltaResult = {
  diff: string;
  percent: string;
  diffColor: DiffColor;
};

interface Options<T> {
  currentPeriodData: T;
  previousPeriodData: T;
  chartType: ChartType;
  token?: string;
  roundNumberBy: number;
  isPositiveRed?: boolean;
}

const getDeltaByChartType = <T extends CommonChartDataBase>({
  currentPeriodData,
  previousPeriodData,
  chartType,
  token,
  roundNumberBy,
  isPositiveRed,
}: Options<T>): TooltipDeltaResult => {
  const diff = (currentPeriodData[chartType] ?? 0) - (previousPeriodData[chartType] ?? 0);
  const percent = safeDivide(diff, previousPeriodData[chartType]) * 100;

  const roundedDiff = roundFloatNumber(diff, roundNumberBy);
  const roundedPercent = roundFloatNumber(percent, 1);

  const result: TooltipDeltaResult = {
    diff: '',
    percent: '',
    diffColor: 'green',
  };

  if (roundedDiff !== 0) {
    const finalDiff = getValueWithToken({
      value: divideBySpaces(roundedDiff),
      token,
    });

    const plusForDiff = roundedDiff > 0 ? '+' : '';
    result.diff = `${plusForDiff}${finalDiff}`;

    if (isPositiveRed) {
      result.diffColor = roundedDiff > 0 ? 'red' : 'green';
    } else {
      result.diffColor = roundedDiff > 0 ? 'green' : 'red';
    }
  }

  if (roundedPercent !== 0) {
    // Если показатель процентный, то вместо символа % показываем п/п
    const tokenMeasure = token === '%' ? 'п/п' : '%';

    const finalPercent = getValueWithToken({
      value: divideBySpaces(roundedPercent),
      token: tokenMeasure,
    });

    const plusForPercent = roundedPercent > 0 ? '+' : '';
    result.percent = `${plusForPercent}${finalPercent}`;

    if (isPositiveRed) {
      result.diffColor = roundedPercent > 0 ? 'red' : 'green';
    } else {
      result.diffColor = roundedPercent > 0 ? 'green' : 'red';
    }
  }

  return result;
};

export {getDeltaByChartType};
